import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiKeyboardArrowDown = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" />
  </SvgWrapper>
);
